<template>
  <v-dialog v-model="dialogVisible" fullscreen persistent>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-btn icon @click="fecharDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <!-- Controles de visualização do PDF -->
        <v-btn icon @click="zoomIn">
          <v-icon>mdi-magnify-plus-outline</v-icon>
        </v-btn>
        <v-btn icon @click="zoomOut">
          <v-icon>mdi-magnify-minus-outline</v-icon>
        </v-btn>
        <v-btn icon @click="rotateClockwise">
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-btn icon @click="rotateCounterClockwise">
          <v-icon>mdi-rotate-left</v-icon>
        </v-btn>
        <v-btn icon @click="resetView">
          <v-icon>mdi-restore</v-icon>
        </v-btn>
        
        <!-- Botão para download do PDF -->
        <v-btn icon :href="pdfUrl" download target="_blank">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="pa-0 fill-height">
        <!-- Container para o PDF com altura total -->
        <div class="pdf-container">
          <iframe v-if="pdfUrl" :src="pdfUrl" class="pdf-viewer" :style="pdfViewerStyle"></iframe>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VisualizarPDF',
  
  props: {
    // Controla a visibilidade do diálogo
    modelValue: {
      type: Boolean,
      default: false
    },
    
    // URL do PDF a ser exibido
    pdfUrl: {
      type: String,
      required: true
    },
    
    // Título a ser exibido na barra superior
    titulo: {
      type: String,
      default: 'Visualizador de PDF'
    }
  },
  
  data() {
    return {
      // Variáveis para controle de zoom e rotação
      zoom: 1,
      rotation: 0
    };
  },
  
  computed: {
    // Controle de visibilidade do diálogo com v-model
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    
    // Estilo para o visualizador de PDF com zoom e rotação
    pdfViewerStyle() {
      return {
        transform: `scale(${this.zoom}) rotate(${this.rotation}deg)`,
        transformOrigin: 'center center',
        transition: 'transform 0.3s ease'
      };
    }
  },
  
  methods: {
    // Fecha o diálogo
    fecharDialog() {
      this.dialogVisible = false;
      this.resetView();
    },
    
    // Aumenta o zoom
    zoomIn() {
      this.zoom = Math.min(this.zoom + 0.2, 3); // Limite máximo de zoom: 3x
    },
    
    // Diminui o zoom
    zoomOut() {
      this.zoom = Math.max(this.zoom - 0.2, 0.5); // Limite mínimo de zoom: 0.5x
    },
    
    // Rotaciona no sentido horário
    rotateClockwise() {
      this.rotation = (this.rotation + 90) % 360;
    },
    
    // Rotaciona no sentido anti-horário
    rotateCounterClockwise() {
      this.rotation = (this.rotation - 90 + 360) % 360;
    },
    
    // Reinicia a visualização
    resetView() {
      this.zoom = 1;
      this.rotation = 0;
    }
  },
  
  // Reinicia o zoom e rotação quando o componente é montado
  mounted() {
    this.resetView();
  }
};
</script>

<style scoped>
/* Estilos para o visualizador de PDF */
.pdf-container {
  width: 100%;
  height: calc(100vh - 64px); /* Altura total menos a altura da toolbar */
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #f0f0f0;
  padding: 20px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: white;
}
</style>
